<template>
  <div class="invoice-viewer-field">
    <div :class="`col-${labelSpan} p-0`">
      <label>
        {{ label }}
        <i v-if="(!!correctText || !!companySituation || !!missingContent) && !suppressChecks" class="fad fa-exclamation-triangle"
          style="--fa-primary-color: #fd2222; --fa-secondary-color: #f4ce35; --fa-secondary-opacity: 1; margin-left: 2px"></i>
      </label>
    </div>
    <div :class="`col-${textSpan} p-0 content ${textBold ? 'bold' : ''}`">
      <span v-if="!!text">{{ text }}</span>
      <div v-if="(!!correctText || !!missingContent) && !suppressChecks">
        <button v-if="!showAlert" class="btn btn-link" @click="showAlert = true">
          <i class="fad fa-exclamation-triangle"
            style="--fa-primary-color: #fd2222; --fa-secondary-color: #f4ce35; --fa-secondary-opacity: 1;"></i>
        </button>
        <b-alert v-model="showAlert" variant="warning" dismissible class="alert-content">
          <div v-if="missingContent" style="margin-right: 24px" v-html="renderMissingContent" />
          <div v-else style="margin-right: 24px" v-html="renderErrorContent" />
        </b-alert>
      </div>
      <div class="badge-warning" v-if="!!companySituation">{{ companySituation }}</div>
      <i v-if="!suppressChecks && isCorrect" class="fad fa-check-circle"
        style="--fa-primary-color: #ffffff; --fa-secondary-color: #2bd700; --fa-secondary-opacity: 1;"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceFormViewerField',
  props: {
    isShowDefault: {
      type: Boolean,
      default: false,
    },
    isCorrect: {
      type: Boolean,
      default: false,
    },
    correctText: {
      type: String,
      default: '',
    },
    companySituation: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    text: {
      type: [String],
      default: '',
    },
    textBold: {
      type: Boolean,
      default: false,
    },
    labelSpan: {
      type: [Number, String],
      default: 3,
    },
    textSpan: {
      type: [Number, String],
      default: 9,
    },
    missingContent: {
      type: Boolean,
      default: false
    },
    suppressChecks: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAlert: true,
    };
  },
  computed: {
    renderMissingContent() {
      return `${this.$t('invoice.missingContentError')} ${this.label}.`
    },
    renderErrorContent() {
      return this.isShowDefault && !!this.correctText
        ? `${this.correctText}`
        : `${this.label} ${this.$t('invoice.viewFieldErrorContent')} "<strong>${this.correctText}</strong>".`;
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-viewer-field {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 4px 0;
  width: 100%;

  .content {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;

    .btn {
      padding: 0
    }

    .badge-warning {
      border-radius: 100px;
      background-color: #fdcd07;
      padding: 8px 16px;
      color: #fd2222;
    }

    .alert-warning {
      border-radius: 8px;
      border: solid 1px #fdcd07;
      background-color: inherit;
      padding: 12px;
      color: #fd2222;
    }

    .alert-content {
      flex-shrink: 0;
      max-width: 500px;
      overflow-y: auto;
      scrollbar-width: none;
    }
  }
  
  label {
    margin-bottom: 0;
    white-space: nowrap;
  }
  span {
    font-size: 14px;
    word-spacing: 1px;
    padding-left: 1rem;
    margin-left: 4px;
  }

  .bold {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-form-viewer-field.vue